export default __webpack_public_path__ + "images/convert_2ff046.svg";